import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import Contact from "@/pages/Contact";

export const Route = createFileRoute("/contact-us")({
  head: () => pageHead({
    title: 'Contact Us',
    description: 'Get in touch with Rex & Sons RVs in Castle Hayne, NC — call, text or visit us for RV sales, service, parts and rentals near Wilmington.',
    path: '/contact-us',
  }),
  component: Contact,
});
